import script from "./NewBeneficiaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewBeneficiaryModal.vue?vue&type=script&setup=true&lang=js"

import "./NewBeneficiaryModal.vue?vue&type=style&index=0&id=3d255e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d255e94"]])

export default __exports__